export enum LanguagePreferenceEnum {
  EN = 'en',
  // TR = 'tr',

  AR = 'ar',
}
